import React from 'react';
import styled from 'styled-components';

import { breakpoints } from '../../utils/breakpoints';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12.81px;
  width: 100%;
  margin: 0 auto;
  padding: 12px 8px;
  background-color: #deecff;
  border-left: solid 20px #5180b1;
  border-radius: 5px;

  svg {
    width: 13px;
    height: 13px;
  }

  @media ${breakpoints.tablet} {
    width: 60%;

    svg {
      width: 26px;
      height: 26px;
    }
  }

  @media ${breakpoints.desktop} {
    width: 80%;
    padding: 14.81px 71px 14.81px 12.81px;
  }
`;

const Content = styled.p`
  margin-bottom: 0;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 0.8125rem;
  color: #4d4d4d;
  line-height: 120%;
  letter-spacing: 0.0025em;

  span {
    display: block;
    margin-top: 4px;
  }

  @media ${breakpoints.tablet} {
    font-size: 0.875rem;
  }
`;

export default function SyncNotification() {
  return (
    <Container>
      <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M13 0.8125C6.26934 0.8125 0.8125 6.26934 0.8125 13C0.8125 19.7307 6.26934 25.1875 13 25.1875C19.7307 25.1875 25.1875 19.7307 25.1875 13C25.1875 6.26934 19.7307 0.8125 13 0.8125ZM17.9037 17.374C17.0606 18.3148 15.9644 18.9929 14.7462 19.3272C13.5279 19.6615 12.2391 19.6378 11.034 19.259C9.82881 18.8802 8.75824 18.1624 7.95028 17.1912C7.14233 16.2201 6.63117 15.0368 6.47793 13.7828C6.28407 13.9111 6.04946 13.9628 5.81964 13.9278C5.58982 13.8929 5.38118 13.7738 5.23422 13.5937C5.08725 13.4136 5.01244 13.1853 5.02431 12.9531C5.03618 12.721 5.13387 12.5015 5.29844 12.3373L6.68125 10.9545C6.8545 10.7813 7.08866 10.6828 7.33364 10.68C7.57861 10.6773 7.81492 10.7705 7.99199 10.9398L9.4375 12.3227C9.59981 12.4767 9.70167 12.6837 9.72468 12.9063C9.74769 13.1289 9.69033 13.3523 9.56296 13.5363C9.43559 13.7203 9.24661 13.8526 9.03018 13.9095C8.81374 13.9663 8.58412 13.9438 8.38281 13.8461C8.54339 14.7101 8.94288 15.5118 9.53598 16.1603C10.1291 16.8088 10.892 17.2781 11.7383 17.515C12.5846 17.7519 13.4803 17.7469 14.3239 17.5006C15.1675 17.2542 15.9251 16.7764 16.5109 16.1213C16.6791 15.9435 16.9101 15.8384 17.1546 15.8286C17.3991 15.8188 17.6377 15.905 17.8196 16.0688C18.0014 16.2326 18.112 16.461 18.1277 16.7052C18.1434 16.9494 18.063 17.19 17.9037 17.3758V17.374ZM20.7021 13.6627L19.3193 15.0455C19.1461 15.2187 18.9119 15.3172 18.667 15.32C18.422 15.3227 18.1857 15.2295 18.0086 15.0602L16.5631 13.6773C16.4039 13.5241 16.3039 13.3196 16.2809 13.0998C16.2578 12.8801 16.3131 12.6592 16.437 12.4763C16.5608 12.2933 16.7454 12.16 16.958 12.0998C17.1706 12.0397 17.3976 12.0565 17.599 12.1475C17.438 11.2854 17.0389 10.4856 16.4468 9.83858C15.8548 9.1916 15.0934 8.72327 14.249 8.48662C13.4045 8.24997 12.5107 8.25445 11.6686 8.49954C10.8266 8.74464 10.0699 9.22056 9.48438 9.87344C9.40216 9.96508 9.3027 10.0396 9.19167 10.0928C9.08064 10.146 8.96022 10.1769 8.83728 10.1835C8.71434 10.1902 8.59129 10.1726 8.47516 10.1317C8.35903 10.0908 8.25209 10.0274 8.16045 9.94522C8.06881 9.863 7.99425 9.76353 7.94105 9.65251C7.88785 9.54148 7.85703 9.42106 7.85037 9.29812C7.8437 9.17518 7.86132 9.05213 7.9022 8.936C7.94309 8.81987 8.00645 8.71293 8.08867 8.62129C8.93241 7.68055 10.0295 7.003 11.2484 6.66978C12.4674 6.33656 13.7565 6.36181 14.9615 6.74251C16.1665 7.12321 17.2362 7.8432 18.0424 8.81626C18.8487 9.78932 19.3573 10.9742 19.5074 12.2289C19.7 12.0976 19.9345 12.0428 20.1653 12.075C20.3961 12.1073 20.6066 12.2243 20.7558 12.4034C20.9049 12.5824 20.9821 12.8106 20.9722 13.0434C20.9623 13.2762 20.866 13.497 20.7021 13.6627Z"
          fill="#5180B1"
        />
      </svg>
      <div>
        <Content>
          <strong>Your information is being synced.</strong>
          <span>You are unable to edit this field. Please select ‘Next’</span>
        </Content>
      </div>
    </Container>
  );
}
